import React, { Component } from 'react'
import myCollectionsMenuStore from '../../stores/myCollectionsMenuStore'
import AddToCollection from '#images/add-to-collection-menu.svg'

class MenuButton extends Component {
  openMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { itemUuid, fetchProductItems } = this.props;
    myCollectionsMenuStore.open(itemUuid, {
      pageX: e.pageX, pageY: e.pageY, clientY: e.clientY, fetchProductItems,
    });
  };

  render() {
    return (
      <div className='flex items-center'>
        <img
          src={AddToCollection}
          alt='Add to Collection'
          className={`object-cover max-w-[21px] max-h-[19px] hover:cursor-pointer ${this.props.invertedColors ? 'brightness-0 hover:brightness-50' : 'brightness-[80%] hover:brightness-125'}`}
          onClick={this.openMenu}
        />
      </div>
    )
  }
}

export default MenuButton;
